@if (!loading && formData) {
  @if (
    formData.outreach_type === outreachFormType.PUBLIC ||
    formData.outreach_type === outreachFormType.GENERIC ||
    formData.outreach_type === outreachFormType.LOAN
  ) {
    <!-- <app-general-outreach-form
      [outreachPrefillData]="formData"
      [uniqueId]="uniqueId"
    ></app-general-outreach-form> -->
    <app-general-outreach-form-v2
      [outreachPrefillData]="formData"
      [uniqueId]="uniqueId"
      [isDemoMode]="isDemoMode"
    ></app-general-outreach-form-v2>
  } @else if (formData.outreach_type === outreachFormType.CRF) {
    <app-crf-outreach-form
      [outreachPrefillData]="formData"
      [connections]="connections"
    ></app-crf-outreach-form>
  }
}

@if (isIdInvalid) {
  <p class="invalid-message">Invalid ID. Please check the URL.</p>
}

@if (isSubmitted) {
  <p class="submission-message">Thank you for your submission.</p>
}
